import {
    useCallback,
    useEffect,
    useState } from "react";
import {
  Modal,
    Box,
    Button,
    List,
    ListItem,
    ListItemButton,
    Typography,
    Grid,
    TextField,
    } from "../../ui";
import { useDispatch,
    useSelector } from "react-redux";
import {
  isRoleAllowed,
  OfferType,
  PARTILBILLAUDIT,
  PayMedium,
  printDebugLog,
  isOtherRoleAllowed,
  OTHER_ADMIN_RIGHTS,
  OTHER_TABLE_OWNER_RIGHTS,
  ROLE_CREATE,
  BILLMGMT,
  ONLINEBILLMGMT
} from "../../../constants/constant";
import {
  addCachedBillProductDetails,
  addItemToBill,
  updateBillDetails,
  updateBillItem,
  updateBillPartialPaymentDetails,
  updateBillPaymentDetails,
} from "../../../store/billDetailsSlice";
import ProductGrid from "../resto/ProductGrid";
import "./product-display.css";
import { INITIAL_BILL_PAYMENT_DETAILS_STATE } from "../../../constants/restoConstant";
import { useSnpUI } from "../../global/snpComponent/SnpUiProvider";
import { isEmpty } from "lodash";
import { getConfigValueByKey } from "../../../utilities/commonUtilities";
import { recalculateBillTotal } from "../../../store/thunk/billCalculatorThunk";
import SnpButton from "../../global/SnpButton";

const ProductDisplay = ({ open, onClose, products, handleRefreshProduct }) => {
  const [isMultiSelectEnabled, setMultiSelectEnabled] = useState(false);
  const [filteredProducts, setFilteredProducts] = useState(products || []);
  const dispatch = useDispatch();
  const { billItems, billDetails, billPaymentDetails } = useSelector(
    (state) => state.bill
  );
  const restoBillConfig = useSelector((state) => state.restoBillConfig);
  const { snackbar } = useSnpUI();

  useEffect(() => {
    if (products && products.length > 0) {
      setFilteredProducts(products); // initialize filteredProducts when products come
    }
  }, [products]);

  if (!open) return null;
  const getProductName = (data) => {
    let name = data.name;
    if (!isEmpty(data.price.name)) name = name + "(" + data.price.name + ")";
    return name;
  };

  const handleProductFilter = (e) => {
    const searchChar = e.target.value.trim();
    if (isEmpty(searchChar)) {
      setFilteredProducts(products); // reset full list
    } else {
      const filteredList = products.filter((item) =>
        item.name.toLowerCase().includes(searchChar.toLowerCase())
      );
      if (filteredList.length > 0) {
        setFilteredProducts(filteredList);
      } else {
        snackbar.show({
          message: `"${searchChar}" is not available in the list`,
          color: "orange",
        });
        setFilteredProducts([]); // show empty if not found
      }
    }
  };
  const handleAddItem = (data) => {
    if (billDetails.isPaid) {
      snackbar.show({
        message: "Can't add item to paid bill",
        color: "red",
      });
      onClose();
    } else if (
      isOtherRoleAllowed(OTHER_TABLE_OWNER_RIGHTS) ||
      isRoleAllowed([BILLMGMT, ONLINEBILLMGMT], ROLE_CREATE) ||
      isOtherRoleAllowed(OTHER_ADMIN_RIGHTS)
    ) {
      //  ;
      printDebugLog("handleAddItem", data);
      //handleProductSelectSinglePrice(data,multipleOptRef.current);
      const transFormedBillItem = {
        ...data,
        prdId: data.id ? data.id : data.prdId,
        price: data.price.sAmt,
      };
      console.log("billItems: " + billItems);
      const item = billItems.find(
        (item) => item.prdId === transFormedBillItem.prdId
      );
      console.log("item: " + JSON.stringify(item));
      if (item) {
        dispatch(
          updateBillItem({
            ...item,
            quantity: item.quantity + 1,
            finalPrice: Number(item.price) * (Number(item.quantity) + 1),
          })
        );
        snackbar.show({
          message:
            item.quantity +
            1 +
            "* " +
            getProductName(data) +
            " added successfully",
          color: "green",
          vertical: "top",
          horizontal: "right",
        });
      } else {
        // ;
        dispatch(
          addItemToBill({
            ...transFormedBillItem,
            name: getProductName(data),
            quantity: 1,
            combo: data.catgId === "snp_combo_id",
            finalPrice: Number(data.price.sAmt) * 1,
          })
        );
        snackbar.show({
          message: "1 * " + getProductName(data) + " added successfully",
          color: "green",
          vertical: "top",
          horizontal: "right",
        });
        console.log("ftg: ", products);
        console.log("data: ", data);
        const product = products.find(
          (prd) =>
            transFormedBillItem.prdId === prd.id ||
            transFormedBillItem.id === prd.id
        );
        console.log("selectedProduct: ", product);
        if (product) {
          dispatch(addCachedBillProductDetails(product));
        }
      }
      if (!isMultiSelectEnabled) {
        onClose();
      }
      dispatch(
        recalculateBillTotal({
          prevTotalPrice: 0,
          newTotalPrice: data.price.sAmt,
          cgstRate: data.cgst,
          sgstRate: data.sgst,
        })
      );
    } else {
      snackbar.show({
        message: "You are not allowed to add items! Contact Admin",
        color: "red",
      });
    }
  };

  return (
    <>
      <div className="modal-overlay" onClick={onClose}></div>
      <div className=" modal-container">
        <Grid container spacing={1} columns={12}>
          <Grid item xs={12} md={4}>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center", // Vertically center all children
                justifyContent: "space-between", // Spread out left, center, right
                width: "100%",
              }}
            >
              <div className="multi-select-toggle">
                <input
                  type="checkbox"
                  id="multiSelect"
                  checked={isMultiSelectEnabled}
                  onChange={() => {
                    setMultiSelectEnabled(!isMultiSelectEnabled);
                    //setSelectedProducts([]); // Clear selections when mode changes
                  }}
                />
                <label htmlFor="multiSelect">
                  {isMultiSelectEnabled
                    ? "Add Single Item"
                    : "Add Multiple Items"}
                </label>
              </div>
            </div>
          </Grid>
          <Grid item xs={6} md={4}>
            <div>
              <TextField
                required
                id="sItem"
                name="sItem"
                variant="filled"
                size="small"
                label="Search Item"
                onChange={handleProductFilter}
                style={{ width: "70%", marginBottom: "15px" }}
              />
            </div>
          </Grid>
          <Grid item xs={6} md={4}>
            <div>
              <SnpButton mbgcolor="#3d6554" onClick={handleRefreshProduct}>
                Refresh Data
              </SnpButton>
            </div>
          </Grid>
        </Grid>

        <div>
          <button className="close-btn" onClick={onClose}>
            ❌
          </button>
        </div>
        {filteredProducts && filteredProducts.length > 0 && (
          <ProductGrid
            filteredCatgProductData={filteredProducts}
            handleItemData={handleAddItem}
          />
        )}
      </div>
    </>
  );
};

export default ProductDisplay;
